import { Component,Directive,NgZone, OnInit,Input,Output,EventEmitter } from '@angular/core';
import { IFrostMeasurementStation } from 'src/app/interfaces/IFrostMeasurementStation';
import {stationListEventService} from '../../shared/services/stationlistEventEmitterService'

@Component({
  selector: 'app-stationlist-item',
  templateUrl: './stationlist-item.component.html',
  styleUrls: ['./stationlist-item.component.scss']
})
export class StationlistItemComponent implements OnInit {
  @Input() station: IFrostMeasurementStation;
  @Output() stationChange: EventEmitter<IFrostMeasurementStation> = new EventEmitter<IFrostMeasurementStation>();
  constructor(private stationlistselection:stationListEventService, private ngzone:NgZone) { }

  ngOnInit(): void {

  }
  selectInmap(station:IFrostMeasurementStation){
    this.station=station;
    this.stationlistselection.onlistSelection(this.station.maetpunktId);
    console.log('Station selected')
  }
}
